import * as kinetic from '../view-advice-kinetic'
import * as anticholinergic from '../view-advice-anticholinergic'
import * as adverse from '../view-advice-adverse'

import * as immu from 'object-path-immutable'
import * as qtc from '../view-advice-qtc'
import * as serotonerg from '../view-advice-serotonerg'
import * as flow from '../view-findings/flow.js'

// -----------------------------------------
// Thunk will refresh questions for rules
// and keep answered questions and add url
// -----------------------------------------
export function questions( varsQ = [] ) {

  return async ( dispatch, getState, api ) => {

    var { xeon } = getState()
    var { faqs } = xeon

    // -----------------------------------------
    // Remove not answered questions from store
    // -----------------------------------------
    for ( const group of Object.keys( faqs ) ) {
      for ( const key of Object.keys( faqs[ group ] ) ) {
        if ( faqs[ group ][ key ] == null ) {
          delete faqs[ group ][ key ]
        }
      }
      // If group id is empty delete group also
      if ( Object.keys( faqs[ group ] ).length == 0 ) {
        delete faqs[ group ]
      }
    }

    // -------------------------------------
    // Add questions from search url without downfall
    // -------------------------------------
    faqs = varsQ.reduce( ( acc, cur ) => {
      return immu.set( acc, cur.key, cur.value )
    }, faqs )

    // -----------------------------------------------------
    // Add additional question missing so far from chapters
    // -----------------------------------------------------
    qtc.questions( xeon ).forEach( key => {
      faqs = flow.setKey( faqs, key )
    } )
    serotonerg.questions( xeon ).forEach( key => {
      faqs = flow.setKey( faqs, key )
    } )

    dispatch( { type: "xeon.faqs", data: faqs } )

    return Promise.resolve()

  }

}
